import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Panel, Btn, Field, Input, Textarea } from "@/admin/ui";

export default function LegalAdmin() {
  const [items, setItems] = useState([]);
  const [sel, setSel] = useState(null);
  const load = () => api.get("/api/admin/legal").then((r) => { setItems(r.data.items || []); });
  useEffect(() => { load(); }, []);
  useEffect(() => { if (items.length && !sel) setSel(items[0]); }, [items, sel]);

  const save = async () => {
    try { await api.put(`/api/admin/legal/${sel.slug}`, { title: sel.title, body: sel.body }); toast.success("Legal page saved"); await load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div data-testid="admin-legal">
      <h1 className="mb-6 text-2xl font-bold text-ink-heading">Legal Pages</h1>
      <div className="mb-4 flex flex-wrap gap-2">
        {items.map((it) => (
          <Btn key={it.slug} variant={sel?.slug === it.slug ? "primary" : "ghost"} onClick={() => setSel(it)} data-testid={`legal-tab-${it.slug}`}>{it.title}</Btn>
        ))}
      </div>
      {sel && (
        <Panel testid="legal-editor">
          <div className="space-y-4">
            <Field label="Title"><Input value={sel.title} onChange={(e) => setSel({ ...sel, title: e.target.value })} /></Field>
            <Field label="Body (HTML allowed)"><Textarea rows={12} value={sel.body} onChange={(e) => setSel({ ...sel, body: e.target.value })} data-testid="legal-body-input" /></Field>
            <Btn onClick={save} data-testid="legal-save">Save</Btn>
          </div>
        </Panel>
      )}
    </div>
  );
}
